export const REVIEW_MODE_CUSTOM = 'custom';
export const REVIEW_MODE_CLIENT_ONLY = 'client_only';
export const REVIEW_MODE_CLIENT_NON_CLIENT = 'client_non_client';

export const CLIENT_ONLY_REVIEW_FIELD_PRESET = [
  'field_expense_date',
  'field_matter',
  'field_imputation_level1',
  'field_cost_type',
  'field_activity',
  'field_supplier_event',
  'field_narrative',
  'field_tips',
  'field_tax_code',
];

export const CLIENT_ONLY_REQUIRED_REVIEW_FIELDS = [
  'field_expense_date',
  'field_matter',
  'field_imputation_level1',
  'field_cost_type',
  'field_activity',
  'field_supplier_event',
];

export const CLIENT_NON_CLIENT_REVIEW_FIELD_PRESET = [
  'field_invoice_date_editable',
  'field_expense_date',
  'field_matter',
  'field_expense_type',
  'field_imputation_level1',
  'field_narrative',
  'field_tips',
  'field_tax_code',
];

export const CLIENT_NON_CLIENT_REQUIRED_REVIEW_FIELDS = [
  'field_expense_date',
  'field_matter',
  'field_expense_type',
  'field_imputation_level1',
];

const ALL_REVIEW_PRESET_FIELD_FLAGS = new Set([
  ...CLIENT_ONLY_REVIEW_FIELD_PRESET,
  ...CLIENT_NON_CLIENT_REVIEW_FIELD_PRESET,
]);

/**
 * Replace all `field_*` module options with a preset; keep non-field options (e.g. review, controller).
 * Only includes preset keys that exist on the server template for this client build.
 *
 * @param {Array<{name: string}>} existingOptions - Current `component.options` from client config
 * @param {string[]} fieldPreset - Field flags to apply
 * @param {string[]} templateOptionNames - Allowed option names from `/clients/components` template
 * @returns {Array<{name: string}>}
 */
export function buildOptionsAfterReviewPreset(existingOptions, fieldPreset, templateOptionNames) {
  const allowed = new Set(templateOptionNames || []);
  const mains = (existingOptions || []).filter((o) => !o.name.startsWith('field_'));
  const withReview = mains.some((o) => o.name === 'review') ? mains : [...mains, { name: 'review' }];
  const fields = (fieldPreset || []).filter((n) => allowed.has(n));
  const presetSet = new Set(fields);
  // Opt-in extension flags (e.g. field_matter_split) are not part of any preset but must
  // survive mode switches — preserve any field_* the admin had enabled that isn't in the preset.
  const preserved = (existingOptions || []).filter(
    (o) =>
      o.name.startsWith('field_') &&
      !presetSet.has(o.name) &&
      !ALL_REVIEW_PRESET_FIELD_FLAGS.has(o.name) &&
      allowed.has(o.name)
  );
  return [...withReview, ...fields.map((name) => ({ name })), ...preserved];
}
